<!-- {{filteredAccounts | json}} -->
<!-- {{selectedAccount | json}} -->
<!-- {{this.searchCtrl.value | json}} -->
<!-- {{accountLookUp.value | json}} -->

<div [formGroup]="accountLookUp">
  <input type="hidden" formControlName="id">

  <mat-form-field>
    <input matInput placeholder="{{title}}" formControlName="name" #Program (blur)="clearifnotypeahead()">
    <mat-error *ngIf="name.errors?.required">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required
    </mat-error>
  </mat-form-field>

</div>

